
import { Component, Prop, Vue } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import CouponApplyRootComponent from '@/components/subs01/CouponApplyRootComponent.vue';
import ErrorForApiComponent from '@/components/ErrorForApiComponent.vue';
import Icon from '@/layouts/Icon.vue';
import OrderApiConfig from '@/api/OrderApiConfig';
import {
  JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicable,
  JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation,
  DPApi,
  JpCoBenefitoneBsSubsidyDtoErrorData,
  GetSubsidyRequest,
  PutSubsidyRequest,
} from '@/openapi/order';
import store from '@/store';
import TargetPersonFormComponent, {
  AgeTypeOption,
  RelationshipOption,
  TargetPerson,
  TargetPersonMaster,
} from '@/components/subs01/TargetPersonFormComponent.vue';
import CouponCollapse from '@/components/subs01/CouponCollapse.vue';
import EnvRepository from '@/repository/EnvRepository';
import ApiService from '@/services/ApiService';
import {
  ChildrenType,
  PriceListItemType,
  SubsidyType,
  AvailableDataType,
  SubsidyAvailableDataListType,
  StayDayType,
  StayNightDetailType,
  StayRoomDetailType,
  VacancyCalendarType,
  CouponMixinApplyCouponResponseType,
  CoupoonMixinManualApplyCouponResponseType,
  CouponApplyDateListType,
  getCouponDescription,
  getSubsidyOptions,
} from '@/plugins/coupon';
import couponMixin from '@/mixins/coupon';
import { COUPON_AGE_TYPE, USED_FORM_DIV, SUBSIDY_REQUEST_TYPE } from '@/constants/coupon';
import ConfirmModal from '@/modals/ConfirmModal.vue';

export type SubsEditModeType = 'EditTargetPerson' | 'EditCouponApply' | 'NoCouponApply';

@Component({
  components: {
    CouponApplyRootComponent,
    ErrorForApiComponent,
    Icon,
    TargetPersonFormComponent,
    CouponCollapse,
    ConfirmModal,
  },
})
export default class Subs01View extends Vue {
  //* ***********************************************************************************/
  // Props
  //* ***********************************************************************************/
  @Prop() public orderSite: number;

  //* ***********************************************************************************/
  // Data
  //* ***********************************************************************************/
  commonErrorResponse: JpCoBenefitoneBsSubsidyDtoErrorData = {
    errorCode: '',
    errorDetail: '',
  };

  // エラーレスポンス格納
  subsidyErrorResponseList: JpCoBenefitoneBsSubsidyDtoErrorData[] = [];

  // APIレスポンス格納
  subsidyGetResponse: SubsidyType = {};

  // 画面の編集モード 'EditTargetPerson' | 'EditCouponApply'
  editMode: SubsEditModeType = 'EditTargetPerson';

  // クーポン適用対象者データ
  targetPersonList: TargetPerson[] = [];

  // クーポン適用対象者 Select候補リスト
  targetPersonMaster: TargetPersonMaster = {
    relationshipOptions: [],
    ageTypeOptions: [],
  };

  isRestoreReservation = false;

  // アラート
  showConfirmModal1 = false;

  showConfirmModal2 = false;

  showConfirmModal3 = false;

  // ApplyCouponから移植
  stayDay = ''; // チェックイン日 "YYYY/MM/DD"

  stayNights = 0; // 宿泊日数

  couponOption = 0; // 自動補助クーポンラジオボタン

  subsidyData: SubsidyAvailableDataListType[] = []; // API取得データ

  forceUseSubsidys: SubsidyAvailableDataListType[] = [];

  visibleCoupons: { [key: string]: boolean } = {};

  vacancyCalendar: { vacancyCalendars: VacancyCalendarType[] } = { vacancyCalendars: [] };

  stayRoomDetails: StayRoomDetailType = []; // ベストチョイスのリクエスト

  stayNightDetails: StayNightDetailType[] = []; // ベストチョイスのレスポンス

  remainingSubsidys: SubsidyAvailableDataListType[] = [];

  totalDiscountAmount = 0;

  totalForceUseDiscount = 0;

  totalAppliedCouponPrice = 0;

  canUseOptional = true;

  couponVerified = false;

  personAccompanyFlg = false;

  memberAdults = 1;

  memberChildDetails: ChildrenType = {
    childrenType10: 0,
    childrenType15: 0,
    childrenType20: 0,
    childrenType30: 0,
    childrenType40: 0,
    childrenType50: 0,
  };

  //* ***********************************************************************************/
  // Computed
  //* ***********************************************************************************/
  // クーポン適用対象者の情報 追加可能フラグ
  get disabledAddTargetPerson(): boolean {
    return this.targetPersonList.length === this.subsidyGetResponse?.headCntTotal;
  }

  // クーポン適用対象者の情報 編集可否フラグ
  get disabledEditTargetPerson(): boolean {
    return this.editMode !== 'EditTargetPerson';
  }

  // 申請確定 ボタン活性フラグ
  get disabledEditCouponApply(): boolean {
    return !(this.editMode === 'EditCouponApply' || this.editMode === 'NoCouponApply');
  }

  // 補助クーポン 段落表示フラグ
  get showCouponView(): boolean {
    if (!this.subsidyGetResponse.availableDataList) return false;
    return this.subsidyGetResponse.availableDataList.length > 0;
  }

  // 補助クーポン 強制・任意の定義
  get usedFormDiv(): { [key: string]: string } {
    return USED_FORM_DIV;
  }

  // アラートモーダル表示フラグ
  get isAlertCafeFlag(): boolean {
    if (!this.subsidyGetResponse.doneApplyCafe || !this.subsidyGetResponse.cafeUsePoint) return false;
    return this.subsidyGetResponse.doneApplyCafe && this.subsidyGetResponse.cafeUsePoint >= 0;
  }

  get isAlertBenepoFlag(): boolean {
    if (!this.subsidyGetResponse.benepoUseFlag || !this.subsidyGetResponse.benepoAmountTotal) return false;
    return this.subsidyGetResponse.benepoUseFlag !== '0' && this.subsidyGetResponse.benepoAmountTotal >= 1;
  }

  // ApplyCouponから移植
  get totalMemberCount(): number {
    return this.memberAdults + Object.values(this.memberChildDetails).reduce((a, b) => a + b, 0);
  }

  get displayCouponOption(): boolean {
    return this.subsidyData.length > this.forceUseSubsidys.length && this.canUseOptional === true;
  }

  //* ***********************************************************************************/
  // 初期表示
  //* ***********************************************************************************/
  mounted(): void {
    store.commit('setIsLoading', true);

    // GET_補助金申請情報の取得
    this.doApiGetSubsidy()
      .then((res) => {
        this.subsidyGetResponse = cloneDeep(res) as SubsidyType;

        // クーポン適用対象者の情報欄_初期化
        this.initMaster();

        // PUT済みデータの復元
        if (res.couponApplicable && res.couponApplicable.length > 0) {
          this.targetPersonList = res.couponApplicable
            .filter((data) => data.couponApplicableNo && data.lastName && data.firstName && data.relationship && data.degreeCount && data.ageType)
            .map(
              (data) => ({
                couponApplicableNo: Number(data.couponApplicableNo),
                lastName: data.lastName,
                firstName: data.firstName,
                relationship: data.relationship,
                degreeCount: data.degreeCount,
                age: data.age ?? '',
                ageType: data.ageType,
              } as TargetPerson)
            );

          if (res.subsidyReservations) {
            this.isRestoreReservation = true;
          }

          if (!res.availableDataList.length) {
            this.commonErrorResponse = {
              errorCode: '',
              errorDetail: EnvRepository.getEnv().VUE_APP_SUBS01_ERR_NO_COUPON,
            };
            this.editMode = 'NoCouponApply';
            return;
          }

          this.editMode = 'EditCouponApply';
          this.$nextTick(() => this.initCoupon());
        }
      })
      .catch((error: unknown) => {
        if (ApiService.isErrorData(error)) {
          this.commonErrorResponse = error;
        } else {
          this.$router.push({
            name: 'Erro01',
          });
        }
      })
      .finally(() => {
        store.commit('setIsLoading', false);
      });
  }

  // クーポン適用対象者の情報欄_初期化
  private initMaster(): void {
    if (
      !this.subsidyGetResponse.scrennDisplayItemList ||
      !this.subsidyGetResponse.scrennDisplayItemList.relationshipPd ||
      !this.subsidyGetResponse.scrennDisplayItemList.relationshipPd.valueList ||
      !this.subsidyGetResponse.scrennDisplayItemList.ageType
    ) {
      return;
    }

    const relationshipOptions: RelationshipOption[] = this.subsidyGetResponse.scrennDisplayItemList.relationshipPd.valueList.map((value) => {
      const strs = value.split('|');
      return {
        label: strs[0],
        code: strs[1],
        degree: strs[2],
      };
    });

    const ageTypeOptions = this.subsidyGetResponse.scrennDisplayItemList.ageType
      .filter((value) => value.ageTypeName && value.ageTypeValue)
      .map(
        (value) => ({
          name: value.ageTypeName,
          value: value.ageTypeValue,
        } as AgeTypeOption)
      );

    this.targetPersonMaster = {
      relationshipOptions,
      ageTypeOptions,
    };
  }

  // GET_DP補助金申請API呼出
  private doApiGetSubsidy(personAccompanyFlag?: string) {
    const config = OrderApiConfig.newInstance();
    const apiOrder = new DPApi(config);

    const requst: GetSubsidyRequest = {
      personAccompanyFlag,
    };

    if (this.orderSite === 4) {
      return apiOrder.getSubsidyFellowTravelers(requst);
    }
    return apiOrder.getSubsidy(requst);
  }

  //* ***********************************************************************************/
  // クーポン適用対象者の情報
  //* ***********************************************************************************/
  // 対象者を追加: アイテムの追加
  clickAddTargetPerson(): void {
    this.targetPersonList.push({
      couponApplicableNo: this.targetPersonList.length + 1,
      firstName: '',
      lastName: '',
      relationship: '',
      degreeCount: '',
      age: '',
      ageType: '',
    });
  }

  // この対象者を削除する: アイテムの削除
  clickDeleteTargetPerson(targetPerson: TargetPerson): void {
    let index = 1;
    const newList = this.targetPersonList
      .filter((item) => item.couponApplicableNo !== targetPerson.couponApplicableNo)
      .map((item) => {
        const newItem: TargetPerson = { ...item, ...{ couponApplicableNo: index } };
        index += 1;
        return newItem;
      });

    this.targetPersonList = newList;
  }

  // 対象者情報を編集: クーポン適用対象者編集モードに戻る
  clickEditTargetPerson(): void {
    this.subsidyGetResponse.availableDataList = [];
    this.editMode = 'EditTargetPerson';

    // エラー表示をリセット
    this.commonErrorResponse = {
      errorCode: '',
      errorDetail: '',
    };
    this.subsidyErrorResponseList = [];

    // GET_補助金申請情報の取得
    this.doApiGetSubsidy('2')
      .then((res) => {
        this.subsidyGetResponse = cloneDeep(res) as SubsidyType;

        if (!res.availableDataList.length) {
          this.commonErrorResponse = {
            errorCode: '',
            errorDetail: EnvRepository.getEnv().VUE_APP_SUBS01_ERR_NO_COUPON,
          };
          this.editMode = 'NoCouponApply';
        }

        // クーポン適用対象者の情報欄_初期化
        this.initMaster();
      })
      .catch((error: unknown) => {
        if (ApiService.isErrorData(error)) {
          this.commonErrorResponse = error;
        } else {
          this.$router.push({
            name: 'Erro01',
          });
        }
      })
      .finally(() => {
        store.commit('setIsLoading', false);
      });
  }

  // 対象者情報を登録: 補助クーポン編集モードに進む
  clickRegistTargetPerson(): void {
    // validate.
    this.validateTargetPerson(this.targetPersonList);
    if (this.commonErrorResponse.errorCode || this.commonErrorResponse.errorDetail) {
      (this.$refs.modalInner as Element).scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const includeMe = this.targetPersonList.some((person) => person.relationship === '0');

    store.commit('setIsLoading', true);

    // GET_補助金申請情報の取得
    this.doApiGetSubsidy(includeMe ? '1' : '0')
      .then((res) => {
        this.subsidyGetResponse = cloneDeep(res) as SubsidyType;

        if (!res.availableDataList.length) {
          this.commonErrorResponse = {
            errorCode: '',
            errorDetail: EnvRepository.getEnv().VUE_APP_SUBS01_ERR_NO_COUPON,
          };
          this.editMode = 'NoCouponApply';
          return;
        }

        this.editMode = 'EditCouponApply';
        this.initCoupon();
      })
      .catch((error: unknown) => {
        if (ApiService.isErrorData(error)) {
          this.commonErrorResponse = error;
        } else {
          this.$router.push({
            name: 'Erro01',
          });
        }
      })
      .finally(() => {
        store.commit('setIsLoading', false);
      });
  }

  // クーポン適用対象者のバリデーションチェック
  private validateTargetPerson(targetPersonList: TargetPerson[]): void {
    // init.
    this.commonErrorResponse = {
      errorCode: '',
      errorDetail: '',
    };

    // no item.
    if (targetPersonList.length === 0) {
      this.commonErrorResponse = {
        errorCode: '',
        errorDetail: EnvRepository.getEnv().VUE_APP_SUBS01_ERR_EMPTY_TARGET_PERSON,
      };
    }

    // check value.
    targetPersonList.forEach((targetPerson) => {
      if (
        !targetPerson.firstName ||
        !targetPerson.lastName ||
        !targetPerson.relationship ||
        !targetPerson.ageType ||
        (targetPerson.ageType === '子供' && !targetPerson.age && targetPerson.age !== 0)
      ) {
        this.commonErrorResponse = {
          errorCode: '',
          errorDetail: EnvRepository.getEnv().VUE_APP_SUBS01_ERR_NO_INPUT,
        };
      } else if (Number(targetPerson.age) < 0) {
        this.commonErrorResponse = {
          errorCode: '',
          errorDetail: EnvRepository.getEnv().VUE_APP_SUBS01_ERR_NEGATIVE,
        };
      } else if (Number(targetPerson.age) > 12) {
        this.commonErrorResponse = {
          errorCode: '',
          errorDetail: EnvRepository.getEnv().VUE_APP_SUBS01_ERR_AGE_OUT_OF_RANGE,
        };
      }
    });
  }

  // 続柄の重複チェック
  checkDegreeCount(couponApplicableNo: number): void {
    this.commonErrorResponse = {
      errorCode: '',
      errorDetail: '',
    };

    const relationshipCodeList = this.targetPersonList.map((targetPerson) => targetPerson.relationship).filter((item) => item !== '');

    if (relationshipCodeList.length > [...new Set(relationshipCodeList)].length) {
      this.targetPersonList[couponApplicableNo - 1].relationship = '';
      this.targetPersonList[couponApplicableNo - 1].degreeCount = '';

      this.commonErrorResponse = {
        errorCode: '',
        errorDetail: EnvRepository.getEnv().VUE_APP_SUBS01_ERR_RELATIONSHIP_ID,
      };

      (this.$refs.modalInner as Element).scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  //* ***********************************************************************************/
  // 補助クーポン
  //* ***********************************************************************************/
  checkVisibleCoupon(subsidy: SubsidyAvailableDataListType): boolean {
    const coupon = JSON.parse(JSON.stringify(subsidy));
    return coupon.availableData.usedFormDiv !== USED_FORM_DIV.FORCED;
  }

  checkDisableByAgeType(ageType: string): boolean {
    return (
      (ageType === COUPON_AGE_TYPE.ADULT && this.stayRoomDetails[0].adultCount === 0) ||
      (ageType === COUPON_AGE_TYPE.CHILDREN && this.stayRoomDetails[0].childrenCount === 0)
    );
  }

  // ベストチョイスの条件により枚数選択できないと判定された場合trueを返す
  checkDisableOptionalCouponNum(price: PriceListItemType): boolean {
    return !price.enabledChangeOptionalCouponCnt;
  }

  // 補助クーポンUIに必要な初期表示
  initCoupon(): void {
    const res = this.subsidyGetResponse;
    const today = moment();

    let subsidyAvailables = res.availableDataList as SubsidyAvailableDataListType[];

    subsidyAvailables = subsidyAvailables.filter(
      (s) =>
        moment(s.availableData.receptionDateFrom).isSameOrBefore(today, 'day') && moment(s.availableData.receptionDateTo).isSameOrAfter(today, 'day')
    );

    // 【補助金健保】7日前制御
    if (!moment().add(7, 'days').isSameOrBefore(this.stayDay, 'day')) {
      subsidyAvailables = subsidyAvailables.filter((s) => s.availableData.fiveDaysAgoControlFlg === '0');
    }

    this.subsidyData = subsidyAvailables
      .filter(
        (c) =>
          c.availableData.useStopFlg === '0' && c.availableData.subsidyType === '01' && (!c.availableRemainingCount || +c.availableRemainingCount > 0)
      )
      .map((e) => {
        e.useCnt = 0;

        // [ISOL_TODO] APIの返り値がnullではなくundefinedになっているので、nullに戻す
        if (e.remainingCount === undefined) e.remainingCount = null;
        if (e.availableRemainingCount === undefined) e.availableRemainingCount = null;
        if (e.remainingAmount === undefined) e.remainingAmount = null;
        if (e.availableRemainingAmount === undefined) e.availableRemainingAmount = null;
        if (e.availableData.minChargeAmt === undefined) e.availableData.minChargeAmt = null;
        if (e.availableData.minTgtAge === undefined) e.availableData.minTgtAge = null;
        if (e.availableData.applicableDegreeCnt === undefined) e.availableData.applicableDegreeCnt = null;
        if (e.availableData.usedMaxCnt === undefined) e.availableData.usedMaxCnt = null;
        if (e.availableData.usedMaxTotalAmt === undefined) e.availableData.usedMaxTotalAmt = null;
        if (e.availableData.parsonalUsedMaxTotalAmt === undefined) e.availableData.parsonalUsedMaxTotalAmt = null;
        if (e.availableData.usedExpectedAmt === undefined) e.availableData.usedExpectedAmt = null;
        if (e.availableData.couponInfo === undefined) e.availableData.couponInfo = null;

        return e;
      });
    this.forceUseSubsidys = cloneDeep(this.subsidyData.filter((c) => c.availableData.usedFormDiv === USED_FORM_DIV.FORCED));
    this.remainingSubsidys = cloneDeep(this.subsidyData);

    // ベストチョイス用の変数を格納
    this.stayDay = res.useDate as string;
    this.stayNights = res.nightCntTotal as number;

    const subTotal = Number(res.subTotal);
    const headCntTotal = Number(res.headCntTotal);
    const nightCntTotal = Number(res.nightCntTotal);
    const chldSubTotalPp = Number(res.chldSubTotalPp);
    const adultsSubTotalPp = Number(res.adultsSubTotalPp);

    let childTypePrice = 0;
    if (!res.chldSubTotalPp && !res.adultsSubTotalPp) {
      childTypePrice = Math.floor(subTotal / headCntTotal / nightCntTotal);
    } else {
      childTypePrice = Math.floor(chldSubTotalPp / nightCntTotal);
    }

    let adultTypePrice = 0;
    if (!res.chldSubTotalPp && !res.adultsSubTotalPp) {
      adultTypePrice = Math.floor(subTotal / headCntTotal / nightCntTotal);
    } else {
      adultTypePrice = Math.floor(adultsSubTotalPp / nightCntTotal);
    }

    let totalMemberChldChrg = 0;
    if (!res.chldSubTotalPp && !res.adultsSubTotalPp) {
      totalMemberChldChrg = Math.floor(subTotal / headCntTotal / nightCntTotal);
    } else {
      totalMemberChldChrg = Math.floor(chldSubTotalPp * Number(res.memberChldDetails?.childrenType10));
    }

    let roomAmount = 0;
    if (!res.chldSubTotalPp && !res.adultsSubTotalPp) {
      roomAmount = Math.floor(subTotal / headCntTotal / nightCntTotal);
    } else {
      roomAmount = Math.floor(adultsSubTotalPp / nightCntTotal + chldSubTotalPp / nightCntTotal);
    }

    const vacancyCalendar: { vacancyCalendars: VacancyCalendarType[] } = { vacancyCalendars: [] };
    for (let i = 0; i < this.stayNights; i += 1) {
      vacancyCalendar.vacancyCalendars.push({
        roomPrice: null,
        price: Math.floor(subTotal / headCntTotal / nightCntTotal),
        adultPrice: adultTypePrice,
        stayDay: this.createStayDay(this.stayDay, i),
        boneSubsidy: 0,
        childrenPriceTable: [
          {
            childDiv: '10',
            childPrice: childTypePrice,
            price: childTypePrice,
            boneSubsidy: 0,
          },
          {
            childDiv: '15',
            childPrice: childTypePrice,
            price: childTypePrice,
            boneSubsidy: 0,
          },
          {
            childDiv: '20',
            childPrice: childTypePrice,
            price: childTypePrice,
            boneSubsidy: 0,
          },
          {
            childDiv: '30',
            childPrice: childTypePrice,
            price: childTypePrice,
            boneSubsidy: 0,
          },
          {
            childDiv: '40',
            childPrice: childTypePrice,
            price: childTypePrice,
            boneSubsidy: 0,
          },
          {
            childDiv: '50',
            childPrice: childTypePrice,
            price: childTypePrice,
            boneSubsidy: 0,
          },
        ],
        reservationDiv: '50',
        stock: 100,
      });
    }
    this.vacancyCalendar = vacancyCalendar;

    const relationships: {
      id: number;
      label: string;
      value: string;
      relationshipCode: string;
      relationship: {
        code: 'C';
        groupName: null;
        relationshipId: string; // "0"
        relationshipName: string;
        relationshipLevel: string; // "0"
        genderDistinction: null;
      };
      age: number | '';
      isMember: boolean;
      isChildren: boolean;
      chldType: 'childrenType10' | '';
      isVisitor: boolean;
    }[] = this.targetPersonList.map((item: TargetPerson) => {
      const itemRelationshipData = this.targetPersonMaster.relationshipOptions.find((option) => Number(item.relationship) === Number(option.code));
      let relationshipName = '';
      let relationshipId = '';
      let relationshipLevel = '';

      if (itemRelationshipData !== undefined) {
        relationshipName = itemRelationshipData.label;
        relationshipId = itemRelationshipData.code;
        relationshipLevel = itemRelationshipData.degree;
      }

      return {
        id: item.couponApplicableNo,
        label: `会員男性 ${item.couponApplicableNo}`,
        value: `会員男性 ${item.couponApplicableNo}`,
        relationshipCode: `C-${relationshipId}-${relationshipLevel}`,
        relationship: {
          code: 'C',
          groupName: null,
          relationshipId,
          relationshipName,
          relationshipLevel,
          genderDistinction: null,
        },
        age: item.age,
        firstName: item.firstName,
        lastName: item.lastName,
        isMember: true,
        isChildren: !!(item.age !== '' && item.age <= 12),
        chldType: item.age !== '' && item.age <= 12 ? 'childrenType10' : '',
        isVisitor: false,
      };
    });

    const memberAdultCnt: number = this.targetPersonList.filter((item: TargetPerson) => item.ageType === '大人').length;

    const stayDays: StayDayType = [];
    for (let i = 0; i < this.stayNights; i += 1) {
      stayDays.push({
        stayDay: this.createStayDay(this.stayDay, i),
        childTypePrice: {
          childrenType10: childTypePrice,
          childrenType15: childTypePrice,
          childrenType20: childTypePrice,
          childrenType30: childTypePrice,
          childrenType40: childTypePrice,
          childrenType50: childTypePrice,
          visitorType10: childTypePrice,
          visitorType15: childTypePrice,
          visitorType20: childTypePrice,
          visitorType30: childTypePrice,
          visitorType40: childTypePrice,
          visitorType50: childTypePrice,
        },
        roomPrice: null, // Math.floor(subTotal / headCntTotal / nightCntTotal)
        price: Math.floor(subTotal / headCntTotal / nightCntTotal),
        adultPrice: adultTypePrice,
        boneSubsidy: 0,
        stock: 100,
        reservationDiv: '50',
        childrenPriceTable: [
          {
            childDiv: '10',
            childPrice: childTypePrice,
            price: childTypePrice,
            boneSubsidy: 0,
          },
          {
            childDiv: '15',
            childPrice: childTypePrice,
            price: childTypePrice,
            boneSubsidy: 0,
          },
          {
            childDiv: '20',
            childPrice: childTypePrice,
            price: childTypePrice,
            boneSubsidy: 0,
          },
          {
            childDiv: '30',
            childPrice: childTypePrice,
            price: childTypePrice,
            boneSubsidy: 0,
          },
          {
            childDiv: '40',
            childPrice: childTypePrice,
            price: childTypePrice,
            boneSubsidy: 0,
          },
          {
            childDiv: '50',
            childPrice: childTypePrice,
            price: childTypePrice,
            boneSubsidy: 0,
          },
        ],
        memberAdultCnt: res.memberAdults || memberAdultCnt,
        memberAdultPrice: adultTypePrice,
        memberAdultChrg: adultTypePrice,
        visitorAdultCnt: 0,
        visitorAdultPrice: 0,
        visitorAdultChrg: 0,
        memberChldCnt: {
          childrenType10: res.memberChldDetails?.childrenType10 || this.targetPersonList.filter((item) => item.ageType === '子供').length,
          childrenType15: res.memberChldDetails?.childrenType15 as number,
          childrenType20: res.memberChldDetails?.childrenType20 as number,
          childrenType30: res.memberChldDetails?.childrenType30 as number,
          childrenType40: res.memberChldDetails?.childrenType40 as number,
          childrenType50: res.memberChldDetails?.childrenType50 as number,
        },
        memberChldPrice: {
          childrenType10: childTypePrice,
          childrenType15: childTypePrice,
          childrenType20: childTypePrice,
          childrenType30: childTypePrice,
          childrenType40: childTypePrice,
          childrenType50: childTypePrice,
        },
        memberChldChrg: {
          childrenType10: childTypePrice,
          childrenType15: 0,
          childrenType20: 0,
          childrenType30: 0,
          childrenType40: 0,
          childrenType50: 0,
        },
        totalMemberChldCnt: res.memberChldDetails?.childrenType10 || this.targetPersonList.filter((item) => item.ageType === '子供').length,
        totalMemberChldChrg,
        visitorChldCnt: {
          childrenType10: 0,
          childrenType15: 0,
          childrenType20: 0,
          childrenType30: 0,
          childrenType40: 0,
          childrenType50: 0,
        },
        visitorChldPrice: {
          childrenType10: 0,
          childrenType15: 0,
          childrenType20: 0,
          childrenType30: 0,
          childrenType40: 0,
          childrenType50: 0,
        },
        visitorChldChrg: {
          childrenType10: 0,
          childrenType15: 0,
          childrenType20: 0,
          childrenType30: 0,
          childrenType40: 0,
          childrenType50: 0,
        },
        totalVisitorChldCnt: 0,
        totalVisitorChldChrg: 0,
      });
    }

    this.stayRoomDetails = [
      {
        stayDays,
        member: { man: 0, woman: 0 },
        visitors: { man: 0, woman: 0 },
        memberChildren: {
          childrenType10: res.memberChldDetails?.childrenType10 || this.targetPersonList.filter((item) => item.ageType === '子供').length,
          childrenType15: res.memberChldDetails?.childrenType15 as number,
          childrenType20: res.memberChldDetails?.childrenType20 as number,
          childrenType30: res.memberChldDetails?.childrenType30 as number,
          childrenType40: res.memberChldDetails?.childrenType40 as number,
          childrenType50: res.memberChldDetails?.childrenType50 as number,
        },
        visitorChildren: {
          childrenType10: 0,
          childrenType15: 0,
          childrenType20: 0,
          childrenType30: 0,
          childrenType40: 0,
          childrenType50: 0,
        },
        adultCount: res.memberAdults || this.targetPersonList.filter((item) => item.ageType === '大人').length,
        childrenCount: res.memberChldDetails?.childrenType10 || this.targetPersonList.filter((item) => item.ageType === '子供').length,
        roomAmount,
        roomNo: 1,
        chldaManHeadCnt: 0,
        chldaWomanHeadCnt: 0,
        vacancyCalendar,
        relationships,
      },
    ];

    this.memberAdults = res.memberAdults as number;
    this.memberChildDetails = res.memberChldDetails as ChildrenType;

    let personAccompanyFlgCount = 0;
    this.stayRoomDetails.forEach((room) => {
      room.relationships.forEach((r) => {
        // check personAccompanyFlg
        if (r.relationship.relationshipId === '0') {
          personAccompanyFlgCount += 1;
        }
      });
    });
    if (personAccompanyFlgCount) this.personAccompanyFlg = true;

    // CHECK VISIBLE COUPONS
    this.subsidyData.forEach((subsidy) => {
      if (this.checkVisibleCoupon(subsidy)) {
        this.visibleCoupons[subsidy.availableData.subsidyId] = true;
      } else {
        this.visibleCoupons[subsidy.availableData.subsidyId] = false;
      }
    });

    this.stayNightDetails = couponMixin.methods.$_couponMixin_convertStayNightDetails(this.stayNights, this.stayRoomDetails, this.subsidyData);

    this.couponOption = 0;
    this.useFullCoupon();
    // if (+this.couponOption === 0) {
    this.couponOption = 1;
    this.onChangeCouponOption();
    // }

    // 補助クーポンまでスクロール
    this.$nextTick(() => {
      (this.$refs.modalInner as Element).scrollTo({
        top: (this.$refs.couponSection as HTMLDivElement).offsetTop,
        behavior: 'smooth',
      });
    });
  }

  // 宿泊日を生成
  createStayDay(startDate: string, count: number): string {
    const date = new Date(startDate.replaceAll('-', '/'));
    date.setDate(date.getDate() + count);
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);

    return `${year}-${month}-${day}`;
  }

  // 補助クーポンの説明を表示
  couponDescription(subsidy: SubsidyAvailableDataListType): string[] {
    return getCouponDescription(subsidy);
  }

  // 自動補助クーポン ラジオボタン変更時
  onChangeCouponOption(): void {
    switch (this.couponOption) {
      case 0:
        this.useFullCoupon();
        break;

      case 1:
        // 送信済みのクーポン適用状況を復元
        if (this.isRestoreReservation && this.subsidyGetResponse.subsidyReservations) {
          this.stayNightDetails.forEach((stayNightItem, stayNightIndex) => {
            const dayCouponList = this.subsidyGetResponse.subsidyReservations?.filter(
              (coupon) => coupon.useDates[0].useScheduleDateTime === stayNightItem.stayDay
            );

            stayNightItem.coupons.forEach((dayCoupon, couponsIndex) => {
              dayCoupon.availableData.priceList.forEach((sCoupon, priceListIndex) => {
                const couponData = dayCouponList?.filter(
                  (rCoupon) =>
                    rCoupon.subsidyDetailId === sCoupon.subsidyDetailId &&
                    rCoupon.ageType === sCoupon.ageType &&
                    rCoupon.priceType === sCoupon.priceType
                );
                this.stayNightDetails[stayNightIndex].coupons[couponsIndex].availableData.priceList[priceListIndex].useCnt = couponData?.length || 0;
              });
            });
          });
          this.isRestoreReservation = false;
        }

        this.couponVerified = false;

        this.stayNightDetails = this.stayNightDetails.map((night: StayNightDetailType) => {
          const newNight = night;
          newNight.coupons = night.coupons.map((coupon) => {
            const newCoupon = coupon;
            newCoupon.availableData.priceList = coupon.availableData.priceList.map((price) => {
              const newPrice = price;
              newPrice.selectUseCnt = price.useCnt;
              newPrice.remaining = price.selectUseCnt || 0;
              return newPrice;
            });
            return newCoupon;
          });
          return newNight;
        });
        this.usePathOfCoupon();
        break;

      case 2:
        this.remainingSubsidys = cloneDeep(
          this.remainingSubsidys.map((s) => {
            const newS = s;
            newS.useCnt = 0;
            return newS;
          })
        );
        this.notUseCoupon();
        break;

      default:
        break;
    }
  }

  // 補助クーポン枚数選択時
  onChangeCouponUseCnt(): void {
    // エラー表示をリセット
    this.commonErrorResponse = {
      errorCode: '',
      errorDetail: '',
    };
    this.subsidyErrorResponseList = [];

    this.stayNightDetails = this.stayNightDetails.map((night) => {
      const newNight = night;
      newNight.coupons = night.coupons.map((coupon) => {
        const newCoupon = coupon;
        newCoupon.availableData.priceList = coupon.availableData.priceList.map((price) => {
          const newPrice = price;
          newPrice.remaining = price.selectUseCnt || 0;
          return newPrice;
        });
        return newCoupon;
      });
      return newNight;
    });

    const result = this.usePathOfCoupon();

    // [ISOL_TODO] missUsePlanはどこから？
    if (result && result.missUsePlan) {
      this.commonErrorResponse = {
        errorCode: '',
        errorDetail: EnvRepository.getEnv().VUE_APP_SUBS01_ERR_OVER_QUANTITY,
      };
      (this.$refs.modalInner as Element).scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  // 自動補助クーポン: 任意補助クーポンを最大限利用する
  useFullCoupon(): void {
    // 【補助金宿泊】補助金情報の宿泊詳細情報変換関数
    const stayNightDetails = couponMixin.methods.$_couponMixin_convertStayNightDetails(
      this.stayNights,
      cloneDeep(this.stayRoomDetails),
      this.subsidyData
    );
    const remainingSubsidys = cloneDeep(this.subsidyData);

    // 【補助金宿泊】補助金申請関数
    const result: CouponMixinApplyCouponResponseType = couponMixin.methods.$_couponMixin_applyCoupon({
      stayDay: this.stayDay,
      stayNights: this.stayNights,
      coupons: remainingSubsidys,
      vacancyCalendar: cloneDeep(this.vacancyCalendar),
      stayRoomDetails: cloneDeep(this.stayRoomDetails),
      stayNightDetails,
    });

    // [ISOL_TODO] totalDiscountAmountが0の場合は合計額が更新されないため、if(result.totalDiscountAmount)で囲わない
    this.stayNightDetails = result.stayNightDetails;
    this.remainingSubsidys = result.remainingSubsidys;
    this.totalForceUseDiscount = result.totalForceUseDiscount || 0;
    this.totalDiscountAmount = result.totalDiscountAmount || 0;
    this.totalAppliedCouponPrice = result.totalAppliedCouponPrice || 0;

    if (result.totalDiscountAmount) {
      if (result.totalDiscountAmount === 0) {
        // auto select dont use coupons option
        this.couponOption = 2;
      }
      if (this.totalDiscountAmount - this.totalForceUseDiscount === 0) {
        this.canUseOptional = false;
      } else {
        this.canUseOptional = true;
      }
    } else {
      this.couponOption = 2;
    }
  }

  // 自動補助クーポン: 選択補助クーポンを一部利用する
  usePathOfCoupon(): { [key: string]: unknown } {
    const remainingSubsidys = cloneDeep(this.subsidyData);

    // RESET useCnt & remainingCount
    const result: CoupoonMixinManualApplyCouponResponseType = couponMixin.methods.$_couponMixin_manualApplyCoupon({
      stayDay: this.stayDay,
      stayNights: this.stayNights,
      coupons: remainingSubsidys,
      vacancyCalendar: this.vacancyCalendar,
      stayRoomDetails: this.stayRoomDetails,
      stayNightDetails: this.stayNightDetails,
      options: {
        applyType: 'manual',
      },
    });

    if (result) {
      if (result.isChangeUsePlan) {
        this.commonErrorResponse = {
          errorCode: '',
          errorDetail: EnvRepository.getEnv().VUE_APP_SUBS01_ERR_OVER_PRICE,
        };
        (this.$refs.modalInner as Element).scrollTo({ top: 0, behavior: 'smooth' });
      }

      this.stayNightDetails = result.stayNightDetails;
      this.remainingSubsidys = result.remainingSubsidys;
      this.totalForceUseDiscount = result.totalForceUseDiscount;
      this.totalDiscountAmount = result.totalDiscountAmount;
      this.totalAppliedCouponPrice = result.totalAppliedCouponPrice;
    } else {
      this.totalForceUseDiscount = 0;
      this.totalDiscountAmount = 0;
      this.totalAppliedCouponPrice = 0;
    }

    return result;
  }

  // 自動補助クーポン: 選択補助クーポンを利用しない
  notUseCoupon(): void {
    const remainingSubsidys = cloneDeep(this.forceUseSubsidys);

    const result: CouponMixinApplyCouponResponseType = couponMixin.methods.$_couponMixin_applyCoupon({
      stayDay: this.stayDay,
      stayNights: this.stayNights,
      coupons: remainingSubsidys,
      vacancyCalendar: this.vacancyCalendar,
      stayRoomDetails: this.stayRoomDetails,
      stayNightDetails: this.stayNightDetails,
      options: {
        applyOptional: false,
      },
    });

    if (result) {
      this.stayNightDetails = result.stayNightDetails;
      this.totalForceUseDiscount = result.totalForceUseDiscount;
      this.totalDiscountAmount = result.totalDiscountAmount;
      this.totalAppliedCouponPrice = result.totalAppliedCouponPrice;

      if (result.totalDiscountAmount === 0) {
        // auto select dont use coupons option
        this.couponOption = 2;
      }
    } else {
      this.totalForceUseDiscount = 0;
      this.totalDiscountAmount = 0;
      this.totalAppliedCouponPrice = 0;
    }
  }

  // 補助クーポン枚数候補リストの生成
  getSubsidyOptions(day: StayNightDetailType, subsidy: SubsidyAvailableDataListType, price: PriceListItemType): { label: string; value: number }[] {
    return getSubsidyOptions(day, subsidy, price, this.totalMemberCount, this.stayNights, this.stayNightDetails);
  }

  // 補助クーポン枚数候補リストの表示フラグ
  checkLimApplicableDateFrom(day: StayNightDetailType, price: PriceListItemType): boolean {
    return (
      moment(price.limApplicableDateFrom).isSameOrBefore(day.stayDay, 'day') && moment(price.limApplicableDateTo).isSameOrAfter(day.stayDay, 'day')
    );
  }

  /**
   * 宿泊日が、任意補助金の限定適用期間内に存在するかを判定し、
   * 画面表示可能かを戻り値とする関数
   *
   * @param {*} day -> stayNightDetails[i]：各宿泊日の情報
   * @param {*} subsidy -> 該当の補助金情報
   * @return boolean -> 画面に表示させるかどうかの判定地
   */
  availableCheckForDate(day: StayNightDetailType, subsidy: SubsidyAvailableDataListType): boolean {
    // 利用可能判定用変数
    let isAvailable = false;
    // 補助金が料金情報を持たない場合は、空の配列で初期化する
    const priceList = subsidy.availableData.priceList || [];

    // 任意の補助金の料金情報リストでループ処理を行い、
    // 宿泊日が限定適用期間内に存在する場合は利用可能とし、処理を抜ける
    for (let i = 0; i < priceList.length; i += 1) {
      if (
        moment(priceList[i].limApplicableDateFrom).isSameOrBefore(day.stayDay, 'day') &&
        moment(priceList[i].limApplicableDateTo).isSameOrAfter(day.stayDay, 'day')
      ) {
        isAvailable = true;
        break;
      }
    }

    return isAvailable;
  }

  // 補助クーポントータル使用枚数
  getTotalUseCnt(subsidy: SubsidyAvailableDataListType): number {
    if (this.couponOption === 1) {
      return subsidy.availableData.priceList.map((r) => r.selectUseCnt || 0).reduce((a, b) => a + b, 0);
    }
    return subsidy.availableData.priceList.map((r) => r.useCnt || 0).reduce((a, b) => a + b, 0);
  }

  /**
   * 企業補助金か判定する
   */
  isCorporate(availableData: AvailableDataType): boolean {
    if (availableData.requestType === SUBSIDY_REQUEST_TYPE.CORPORATE) {
      return true;
    }
    return false;
  }

  /**
   * 画面表示用：上限枚数を取得
   * @arg     object[subsidyList]
   * @return: array
   */
  remainingCountLabel(subsidy: SubsidyAvailableDataListType): string[] {
    const countLabelArr = subsidy?.scrennDisplayItemList?.remainingCountLabel?.value?.split(',') || [];
    const countLabel = [];
    countLabelArr.forEach((val) => {
      if (!val.includes('上限回数') && !val.includes('|null')) {
        countLabel.push(val.replace('|', '：'));
      }
    });
    return countLabel;
  }

  /**
   * 画面表示用：上限金額を取得
   * @arg     object[subsidyList]
   * @return  array
   */
  remainingAmountLabel(subsidy: SubsidyAvailableDataListType): string[] {
    const amountLabelArr = subsidy.scrennDisplayItemList?.remainingAmountLabel?.value?.split(',') || [];
    const amountLabel = [];
    amountLabelArr.forEach((val) => {
      if (!val.includes('上限金額') && !val.includes('|null')) {
        amountLabel.push(val.replace('|', '：'));
      }
    });
    return amountLabel;
  }

  //* ***********************************************************************************/
  // モーダル操作
  //* ***********************************************************************************/
  // キャンセル: モーダルを閉じる
  clickCancel(): void {
    this.$emit('close');
  }

  // 確定時にアラートモーダルを表示
  clickSubmitPre(): void {
    if (this.isAlertCafeFlag && this.isAlertBenepoFlag) {
      this.showConfirmModal3 = true;
    } else if (this.isAlertCafeFlag) {
      this.showConfirmModal1 = true;
    } else if (this.isAlertBenepoFlag) {
      this.showConfirmModal2 = true;
    } else {
      this.clickSubmit();
    }
  }

  onConfirmSubmit(): void {
    this.showConfirmModal1 = false;
    this.showConfirmModal2 = false;
    this.showConfirmModal3 = false;
    this.clickSubmit();
  }

  onConfirmCancel(): void {
    this.showConfirmModal1 = false;
    this.showConfirmModal2 = false;
    this.showConfirmModal3 = false;
  }

  // 確定: 登録API呼出
  clickSubmit(): void {
    const config = OrderApiConfig.newInstance();
    const apiOrder = new DPApi(config);
    store.commit('setIsLoading', true);

    // couponApplicableの組み立て
    const couponApplicable: JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicable[] = this.targetPersonList.map((data) => ({
      ...data,
      ...{
        couponApplicableNo: data.couponApplicableNo.toString(),
        age: data.age as number
      },
    }));

    // reservationsの組み立て
    const reservations: CouponApplyDateListType[] = [];
    let subsidyRequiredAmountTotal: number = this.totalForceUseDiscount;
    let subsidyNoRequiredAmountTotal: number = this.totalDiscountAmount - this.totalForceUseDiscount;

    if ((subsidyRequiredAmountTotal === 0 && subsidyNoRequiredAmountTotal === 0) || !this.subsidyGetResponse.availableDataList.length) {
      // reservations[] を空でリクエストする
      subsidyRequiredAmountTotal = 0;
      subsidyNoRequiredAmountTotal = 0;
    } else {
      this.stayNightDetails.forEach((stayNightDetail) => {
        stayNightDetail.rooms.forEach((room) => {
          room.relationships.forEach((relationship) => {
            relationship.appliedCoupons.forEach((appliedCoupon) => {
              // couponInfoがnullの場合、couponIdにnullを渡す
              const isNullCouponInfo = appliedCoupon.availableData.couponInfo === null;

              const addReservationItem: CouponApplyDateListType = {
                couponId: isNullCouponInfo ? null : appliedCoupon.availableData.couponInfo[0].couponId,
                subsidyId: appliedCoupon.availableData.subsidyId,
                subsidyDetailId: appliedCoupon.availableData.subsidyDetailId,
                relationship: relationship.relationship.relationshipId,
                degreeCount: relationship.relationship.relationshipLevel,
                age: relationship.age !== '' ? relationship.age : null,
                firstName: relationship.firstName,
                lastName: relationship.lastName,
                ageType: appliedCoupon.applyPrice?.ageType || null,
                priceType: appliedCoupon.applyPrice?.priceType || null,
                useDates: [
                  {
                    useScheduleDateTime: stayNightDetail.stayDay,
                    subsidyPriceId: appliedCoupon.applyPrice?.subsidyPriceId || null,
                    price: String(appliedCoupon.applyPrice?.price) ? appliedCoupon.applyPrice?.price : null,
                  },
                ],
                groupId: appliedCoupon.availableData.groupInfo?.groupId || null,
              };
              reservations.push(addReservationItem);
            });
          });
        });
      });
    }

    // PUT_補助金申請を確定
    const request: PutSubsidyRequest = {
      jpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest: {
        couponApplicable,
        reservations: reservations as JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation[],
        subsidyRequiredAmountTotal,
        subsidyNoRequiredAmountTotal,
      },
    };

    if (this.orderSite === 4) {
      apiOrder
        .putSubsidyFellowTravelers(request)
        .then(() => {
          store.commit('setIsLoading', false);
          this.$emit('submit');
        })
        .catch((error) => {
          store.commit('setIsLoading', false);
          if (error.status === 400) {
            error.json().then((json: { errorResponseList: { errorCode: string; errorDetail: string }[] }) => {
              this.subsidyErrorResponseList = json.errorResponseList;
              (this.$refs.modalInner as Element).scrollTo({ top: 0, behavior: 'smooth' });
            });
          } else {
            this.$router.push({
              name: 'Erro01',
            });
          }
        })
        .then(() => {
          this.subsidyErrorResponseList = [];
        });
    } else {
      apiOrder
        .putSubsidy(request)
        .then(() => {
          store.commit('setIsLoading', false);
          this.$emit('submit');
        })
        .catch((error) => {
          store.commit('setIsLoading', false);
          if (error.status === 400) {
            error.json().then((json: { errorResponseList: { errorCode: string; errorDetail: string }[] }) => {
              this.subsidyErrorResponseList = json.errorResponseList;
              (this.$refs.modalInner as Element).scrollTo({ top: 0, behavior: 'smooth' });
            });
          } else {
            this.$router.push({
              name: 'Erro01',
            });
          }
        })
        .then(() => {
          this.subsidyErrorResponseList = [];
        });
    }
  }

  //* ***********************************************************************************/
  // 共通処理
  //* ***********************************************************************************/
  convertPrice(value?: number): string {
    if (!value) return '0';
    return value.toLocaleString();
  }

  convertDate(value?: string): string {
    if (!value) return '';
    return value.replaceAll('-', '/');
  }
}
